const courses = [
  {
    title: 'JavaScript'
  },
  {
    title: 'Python'
  },
  {
    title: 'Django'
  },
  {
    title: 'HTML5'
  },
  {
    title: 'CSS/SASS'
  },
  {
    title: 'React.js'
  },
  {
    title: 'Bootstrap'
  },
  {
    title: 'PostgreSQL/SQLite3/SQL'
  },
  {
    title: 'Docker'
  },
  {
    title: 'JSON'
  },
  {
    title: 'RESTful APIs'
  },
  {
    title: 'CI/CD'
  },
  {
    title: 'AWS: EC2'
  },
  {
    title: 'Polling/Queueing '
  },
  {
    title: 'Monoliths/Microservices'
  },
  {
    title: 'GitHub/Git'
  },
  {
    title: 'Object Oriented Programming'
  },
];

export default courses;
